import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  closeGlobalModal,
  openGlobalModal,
} from "common/utils/modalController";
import { DefaultTextModal } from "../Modal/DefaultTextModal";
import { useAccessContext } from "./AccessContext";

export const ProtectedRoute = ({ hasAccess, children }) => {
  const navigate = useNavigate();
  const { isLoaded, hasToken } = useAccessContext();
  const hasEverLoaded = useRef(false);
  const modalShown = useRef(false);

  useEffect(() => {
    if (isLoaded) hasEverLoaded.current = true;
  }, [isLoaded]);

  useEffect(() => {
    if (modalShown.current) return;

    if (!hasToken || (isLoaded && !hasAccess)) {
      modalShown.current = true;
      openGlobalModal({
        blockOuter: true,
        content: (
          <DefaultTextModal.Message
            message={"Invalid Access"}
            onOk={() => {
              closeGlobalModal();
              navigate("/welcome");
            }}
          />
        ),
      });
    }
  }, [hasAccess, isLoaded, hasToken, navigate]);

  if (!hasToken) return null;
  if (isLoaded && !hasAccess) return null;
  if (!isLoaded && !hasEverLoaded.current) return null;
  return children;
};
